export const STEP_OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export const HACCP_POSITION = {
  B: {
    Id: 'B',
    Description: 'Before',
  },
  A: {
    Id: 'A',
    Description: 'After',
  },
};

export const HACCP_POSITIONS = [
  {
    Id: 'B',
    Description: 'Before',
  },
  {
    Id: 'A',
    Description: 'After',
  },
];

export const HACCP_POSITION_OPTIONS = [
  {
    value: 'B',
    key: 'B',
    text: 'Before',
  },
  {
    value: 'A',
    key: 'A',
    text: 'After',
  },
];

export const LEFTOVER_RULES = [
  {
    value: null,
    key: 'null',
    text: '',
  },
  {
    value: 0,
    key: 0,
    text: 'No Leftovers',
  },
  {
    value: 1,
    key: 1,
    text: '1 Day',
  },
  {
    value: 2,
    key: 2,
    text: '2 Days',
  },
  {
    value: 3,
    key: 3,
    text: '3 Days',
  },
  {
    value: 4,
    key: 4,
    text: '4 Days',
  },
  {
    value: 5,
    key: 5,
    text: '5 Days',
  },
];

export const DELETE_RECIPE_SCENARIOS = {
  NOTIFY: 1,
  ALLOW_SET_INACTIVE: 2,
};

export const ADD_INGREDIENT_HEADER = 'Add Ingredient';
export const SELECT_FAT_HEADER = 'Select Fat';



// WEBPACK FOOTER //
// ./src/pages/managerecipe/helpers/constants.js